import { useCallback } from 'react';
import cn from 'classnames';

import KnobInput from 'components/form/KnobInput.component';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './ImageOptionsInput.module.scss';

const ImageOptionsInput = ({ name: nameFromProps, onChange, options, tag: tagFromProps, value, columns, variant }) => {
  const name = fromAnyToTrimmed(nameFromProps);
  const tag = fromAnyToTrimmed(tagFromProps);

  const handleClick = useCallback(
    //
    (ev) => void call(`ImageOptionsInput.onChange`, onChange, { name, tag, raw: ev.raw }),
    [name, onChange, tag],
  );

  return (
    <div
      data-bem="ImageOptionsInput"
      data-tag={tag}
      className={cn({
        [CN.component]: true,
        [CN[`${columns}Columns`]]: columns,
        [CN[`${variant}Variant`]]: variant,
      })}
    >
      <div data-bem="WidgetColorMode__list" data-tag={tag} className={CN.list}>
        {options.map((o) => (
          <div
            className={cn({
              [CN.templateContainer]: true,
              [CN.selected]: value === o.id,
            })}
            key={createNodeKey({ tag: o.description, unique: o.id })}
          >
            <KnobInput
              variant="colorBox"
              tag="WidgetColorMode__item"
              name=""
              value={o}
              selected={value === o.id}
              onClick={handleClick}
            />
            <div className={CN.imageContainer} style={{ backgroundImage: `url(${o.src})` }} />
            <div className={CN.flex}>
              <div className={CN.title}>{o.description}</div>
            </div>
            <TooltipForReceptionist where={IN.colorSettings} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageOptionsInput;
